import { render, staticRenderFns } from "./SideSlide.vue?vue&type=template&id=77fd24b6&"
import script from "./SideSlide.vue?vue&type=script&lang=js&"
export * from "./SideSlide.vue?vue&type=script&lang=js&"
import style0 from "./SideSlide.vue?vue&type=style&index=0&id=77fd24b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports